import BackButton from "components/Button/BackButton"
import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { EmptyString, FormTypeAdd, FormTypeEdit, StatusCodeActive, StatusCodeDelete } from "utils/Constant"
import { removeNonNumeric } from "utils/helpers"
import UnDeleteButton from "components/Button/UnDeleteButton"
import { FormCard, PagesFormTitle } from "components/Cards"
import { useModal } from "context/ModalContext"
import { useCallApi } from "api/apiHooks"

export default function BankForm(){
    const navigate = useNavigate()
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchInsertBank, fetchUpdateBank, fetchDeleteBank, fetchBankById } = useCallApi()

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramBankId = queryString.get("bankId")

    const [bankCode, setBankCode] = useState(EmptyString)
    const [bankName, setBankName] = useState(EmptyString)
    const [callCenter, setCallCenter] = useState(EmptyString)

    const bankCodeChange = (e) => { setBankCode(e.target.value.toUpperCase()) }
    const bankNameChange = (e) => { setBankName(e.target.value.toUpperCase()) }
    const callCenterChange = (e) => { setCallCenter(removeNonNumeric(e.target.value)) }

    const [createDate, setCreateDate] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)

    const saveBtnClick = async () => {
        const isConfirmed = await confirm()

        if (isConfirmed) {
            showLoading()

            try {
                if (formType === FormTypeAdd){
                    const res = await fetchInsertBank(bankCode, bankName, callCenter)
                    if (!res) return
                }else{
                    const res = await fetchUpdateBank(paramBankId, bankCode, bankName, callCenter)
                    if (!res) return
                }
            } finally {
                hideLoading()
                showSuccess({
                    onSuccess: () => {
                        navigate("/setting/bank")
                    }
                })
            }
        }
    }
    const deleteBtnClick = async () => {
        const isConfirmed = await confirm()

        if (isConfirmed) {
            showLoading()

            try {
                const res = await fetchDeleteBank(paramBankId, status)
                if (!res) return
            } finally {
                hideLoading()
                showSuccess({
                    onSuccess: () => {
                        navigate("/setting/bank")
                    }
                })
            }
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    useEffect(() => {
        if (formType === FormTypeEdit){
            showLoading()

            try {
                fetchBankById(paramBankId).then((res) => {
                    if (!res) return

                    let data = res.data

                    setBankCode(data.bankCode)
                    setBankName(data.bankName)
                    setCallCenter(data.callCenter)
                    setStatus(data.status)
                    setCreateDate(data.createDate)
                    setUpdateDate(data.updateDate)
                    setUpdateBy(data.updateBy)
                })
            } finally {
                hideLoading()
            }
        }
    }, [])

    return (
        <div className="flex flex-col gap-2">
            <PagesFormTitle
                title='Bank Detail'
                formType={formType}
                status={status}
                createDate={createDate}
                updateBy={updateBy}
                updateDate={updateDate}
            />

            <div className="mt-5 flex flex-col gap-3">
                {/* Bank Code */}
                <FormCard title='Bank Code'>
                    <input className="input" value={bankCode} onChange={bankCodeChange} maxLength={20} />
                </FormCard>
                <FormCard title='Bank Name'>
                    <input className="input" value={bankName} onChange={bankNameChange} maxLength={50} />
                </FormCard>
                <FormCard title='Call Center'>
                    <input className="input" value={callCenter} onChange={callCenterChange} maxLength={20} />
                </FormCard>
            </div>
                
            <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />
                <DeleteButton onClick={deleteBtnClick} visible={formType === FormTypeAdd ? false : (status === StatusCodeActive ? true : false)} />
                <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === StatusCodeDelete ? true : false) : false} />
                <BackButton onClick={backBtnClick} />
            </div>
        </div>
    )
}